import { Clickable, Col, Icon, Post, PostBox, Row, Spinner2, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import GetTheApp from 'screens/GetTheApp';
import { getData } from './lib';

const PostsFeed = () => {
  const [fetching, setFetching] = useState(false),
    [selectedPost, setSelectedPost] = useState(-1),
    [localData, setLocalData] = useState([]),
    [type, setType] = useState(null),
    [title, setTitle] = useState(null),
    { isMobile } = useSelector((state) => state.appState),
    { id } = useParams(),
    dataFromState = useSelector((state) => state.home?.posts)?.filter(
      (post) => post.metaData || post.youtubeId || (post.media[0] && post.media[0]?.uri)
    ), // only display the post with media
    { t } = useTranslation(),
    dispatch = useDispatch(),
    navigate = useNavigate(),
    data = type === 'home' ? dataFromState : localData;

  useEffect(() => {
    if (isMobile) return;

    const foundType = getTypes();
    setType(foundType.type);

    if (foundType.title) setTitle(foundType.title);
    if (foundType.type === 'home') return;

    fetchData();
  }, [id]);

  useInfiniteScroll(null, fetchData);

  function getTypes() {
    switch (true) {
      // case ObjectId.isValid(id):
      //   return { type: 'user' }
      case id === 'home' || !id:
        return { type: 'home', title: t('home.latestPosts') };
      default:
        return { type: 'tag', title: `#${id}` };
    }
  }

  function fetchData() {
    if (isMobile) return;

    getData({
      fetching,
      setFetching,
      dispatch,
      data,
      localData,
      setLocalData,
      setTitle,
      id: id,
      type: getTypes().type
    });
  }

  function handleNext() {
    // if(data.length - selectedPost < 5) fetchMore()

    setSelectedPost(selectedPost + 1);
  }

  function handleClick(index) {
    setSelectedPost(index);
  }

  // Currently mobile view is not supported
  if (isMobile) return <GetTheApp alwaysShow />;

  return (
    <Col wid="100%" centerAll noFlex>
      <Col
        noFlex
        wid={isMobile ? '100vw' : '936px'}
        start
        center
        pad="0 0 64px"
        marg={isMobile ? '16px 0 0' : '38px 0 0'}
      >
        <Row pad={isMobile && '0 16px'} center>
          <Clickable marg="0 12px 0 0" onClick={() => navigate(-1)}>
            <Row ht="38px" wid="38px" hasBorder="2px solid #000" hasRadius="32px" centerAll noFlex>
              <Icon type="arrowLeft" dimensions={16} col={theme.GREY_50} />
            </Row>
          </Clickable>

          <Text h2>{title}</Text>
        </Row>

        <Row marg="24px 0 0" wrapFlex gap="20px 24px" start>
          {data?.map((x, i) => (
            <PostBox key={i} item={x} index={i} onClick={handleClick} />
          ))}
        </Row>
      </Col>

      {fetching && (
        <Row pad="10px 0 30px">
          <Spinner2 />
        </Row>
      )}

      {selectedPost !== -1 && (
        <Post
          showBack={selectedPost !== 0}
          handleBack={() => setSelectedPost(selectedPost - 1)}
          showNext={selectedPost !== data.length - 1}
          handleNext={handleNext}
          item={data[selectedPost]}
          handleClose={() => setSelectedPost(-1)}
        />
      )}
    </Col>
  );
};

export default PostsFeed;
